import { Injectable, inject } from '@angular/core';
import { AuthActions } from '@interacta-shared/data-access-auth';
import {
    closeCurrentProTip,
    closeCurrentTip,
} from '@interacta-shared/feature-tip';
import { GenericAppRoute } from '@interacta-shared/util-common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { map } from 'rxjs';
import { BoundedTipConfig } from '../services/bounded-tip.service';

@Injectable()
export class BoundedTipEffects {
    private actions = inject(Actions);

    closeTipsOnLogin$ = createEffect(() =>
        this.actions.pipe(
            ofType(AuthActions.login),
            map(() => closeCurrentTip()),
        ),
    );

    closeTipsOnRouterNavigation$ = createEffect(() =>
        this.actions.pipe(
            ofType(routerNavigatedAction),
            // if a boundary is defined, close current proTip
            map(() =>
                closeCurrentProTip({
                    condition: async (payload) =>
                        payload != null &&
                        !!(
                            payload as BoundedTipConfig<
                                undefined,
                                GenericAppRoute
                            >['payload']
                        )?.boundary,
                }),
            ),
        ),
    );
}
